import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRequest, postRequest, putRequest, deleteRequest } from '../../../axios/requests';
import API from '../../../constant.api';

export const createInterestScheme = createAsyncThunk(
  'interestscheme/create',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.LOAN_INTEREST, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createBankInterestScheme = createAsyncThunk(
  'bankinterestscheme/create',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.BANK_INTEREST, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateBankInterestScheme = createAsyncThunk(
  'bankinterestscheme/update',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { id, ...body } = payload;
      const res = await putRequest(`${API.BANK_INTEREST}/${id}`, body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createBankAccount = createAsyncThunk(
  'bankaccount/create',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.BANK_ACCOUNT_NAMES, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createBank = createAsyncThunk(
  'bank/create',
  async (payload: any, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.BANKS, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getInterestScheme = createAsyncThunk(
  'interestscheme/get',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.LOAN_INTEREST, {});
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBankInterestScheme = createAsyncThunk(
  'bankinterestscheme/get',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.BANK_INTEREST,{branch: payload.branch});
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBank = createAsyncThunk(
  'bank/get',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.BANKS, {});
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBranch = createAsyncThunk(
  'branch/get',
  async (payload: any, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.BRANCHES, {});
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getBankAccountNamesWithStats = createAsyncThunk(
  'bankaccount/stats',
  async (payload: { branch: string }, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(`${API.CUSTOMERS}/bank-account-stats`, { branch: payload.branch });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export interface BankAccountLimitsPayload {
  id: string;
  maxAmountLimit?: number;
  pledgeLimit?: number;
  bankBranches?: Array<{
    bank: string;
    branch: string;
    maxAmountLimit?: number;
    pledgeLimit?: number;
    minimumBalancePaid?: number;
  }>;
}

export const updateBankAccountLimits = createAsyncThunk(
  'bankaccount/updateLimits',
  async (payload: BankAccountLimitsPayload, { rejectWithValue }) => {
    try {
      const { id, ...body } = payload;
      const res = await putRequest(`${API.CUSTOMERS}/${id}/limits`, body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createAgent = createAsyncThunk(
  'agent/create',
  async (payload: { branch: string; agentCode: string; agentName: string }, { rejectWithValue }) => {
    try {
      const res = await postRequest(API.AGENTS, payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAgents = createAsyncThunk(
  'agent/getAll',
  async (payload: { branch?: string; search?: string; page?: number; limit?: number }, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(API.AGENTS, payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAgentsByBranch = createAsyncThunk(
  'agent/getByBranch',
  async (payload: { branch: string }, { rejectWithValue }) => {
    try {
      const { data } = await getRequest(`${API.AGENTS}/by-branch`, payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAgent = createAsyncThunk(
  'agent/update',
  async (payload: { id: string; agentCode?: string; agentName?: string; branch?: string }, { rejectWithValue }) => {
    try {
      const { id, ...body } = payload;
      const res = await putRequest(`${API.AGENTS}/${id}`, body);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteAgent = createAsyncThunk(
  'agent/delete',
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await deleteRequest(`${API.AGENTS}/${id}`);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
